<template>
    <span class="image-bit" ref="image-bit" :style="{ width: imageData.width, top: imageData.top, left: imageData.left }">
        <span class="rotate-control" :style="{ transform: 'rotate(' + imageData.rotation + ')' }">
            <img :src="imageData.path" v-if="imageData.isImage" alt="" />
            <span class="custom" v-if="!imageData.isImage">
                <span v-if="imageData.type === 'tag'" :class="imageData.path">{{ TagTranslation ? $t(TagTranslation) : imageData.value }}</span>
                <span v-else :class="imageData.path">{{ imageData.value !== "undefined" ? imageData.value : "" }}</span>
            </span>
        </span>
    </span>
</template>

<script>
import { scrollTo } from "@/utils";
import { mapGetters } from "vuex";

export default {
    props: {
        id: {
            type: String,
            default() {
                return `image-bit-${this._uid}`;
            },
        },
        imageData: Object,
    },

    computed: {
        TagTranslation() {
            if (this.imageData.type === "tag") {
                switch (this.imageData.value) {
                    case "tap":
                        return "global.tap";
                        break;
                    case "tap tap":
                        return "global.tap_tap";
                        break;
                    case "swipe":
                        return "global.swipe";
                        break;
                    case "hold":
                        return "global.hold";
                        break;
                    default:
                        console.error("translation not specified, Please add a case.");
                        return null;
                }
            } else {
                return null;
            }
        },
    },
};
</script>
